import React from 'react';
import { Button } from '../../components/ui/button';
import { COMPANY } from '../../config/company';

const LeadTabNavigation = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="flex space-x-1 mb-6 overflow-x-auto pb-2 border-b border-gray-200">
      {tabs.map(tab => {
        const Icon = tab.icon;
        return (
          <Button
            key={tab.id}
            variant={activeTab === tab.id ? 'default' : 'ghost'}
            onClick={() => setActiveTab(tab.id)}
            className={`whitespace-nowrap ${activeTab === tab.id ? 'text-white' : 'text-gray-600 hover:text-gray-900'}`}
            style={activeTab === tab.id ? { backgroundColor: COMPANY.primaryColor } : {}}
            data-testid={`tab-${tab.id}`}
          >
            <Icon className="mr-2 h-4 w-4" />
            {tab.label}
            {tab.count > 0 && (
              <span className="ml-2 bg-white/20 rounded-full px-2 py-0.5 text-xs">{tab.count}</span>
            )}
          </Button>
        );
      })}
    </div>
  );
};

export default LeadTabNavigation;
